export const ENTITIES = {
    AUT: [
        'GmbH',
        'AG',
        'OG',
        'KG',
        'GesbR',
        'SE',
        'e.U.',
        'GmbH & Co KG',
        'OEG',
        'KEG',
    ],
    BEL: [
        'SA/NV',
        'SPRL/BVBA',
        'SCRL/CVBA',
        'SNC/VOF',
        'SCS/COMM.V',
        'SC',
        'SCA',
        'SE',
        'ESV',
        'GIE',
    ],
    BGR: [
        'EOOD',
        'OOD',
        'AD',
        'EAD',
        'KD',
        'SD',
        'KDA',
        'ET',
        'SE',
        'UPP',
    ],
    HRV: [
        'd.o.o.',
        'd.d.',
        'j.d.o.o.',
        'k.d.',
        'j.t.d.',
        'OPG',
        'obrt',
        'ZZ',
        'SE',
        'zadruga',
    ],
    CYP: [
        'Ltd',
        'PLC',
        'A.E.',
        'O.E.',
        'E.E.',
        'SE',
        'SCE',
        'V.A.T.',
        'EPF',
        'GP',
    ],
    CZE: [
        's.r.o.',
        'a.s.',
        'k.s.',
        'v.o.s.',
        'družstvo',
        'SE',
        'SCE',
        'SVJ',
        'SO',
        'OSVČ',
    ],
    DNK: [
        'ApS',
        'A/S',
        'P/S',
        'IVS',
        'K/S',
        'F.M.B.A.',
        'AMBA',
        'SE',
        'SCE',
        'SMBA',
    ],
    EST: [
        'OÜ',
        'AS',
        'TÜ',
        'UÜ',
        'FIE',
        'MTÜ',
        'SA',
        'SE',
        'TÜH',
        'OSÜ',
    ],
    FIN: [
        'Oy',
        'Oyj',
        'Ky',
        'Ay',
        'osuuskunta',
        'rekisteröity yhdistys',
        'SE',
        'SCE',
        'Osk',
        'Avoin yhtiö',
    ],
    FRA: [
        'SARL',
        'SAS',
        'SASU',
        'SA',
        'SCI',
        'SNC',
        'SCA',
        'SCOP',
        'GIE',
        'EI',
    ],
    DEU: [
        'GmbH',
        'AG',
        'KG',
        'OHG',
        'GmbH & Co. KG',
        'UG',
        'eG',
        'SE',
        'GbR',
        'KGaA',
    ],
    GRC: [
        'AE',
        'EPE',
        'OE',
        'EE',
        'IKE',
        'PC',
        'SCE',
        'SE',
        'GE',
        'Koin.S.Ep.',
    ],
    HUN: [
        'Kft.',
        'Rt.',
        'Nyrt.',
        'Zrt.',
        'Bt.',
        'Kkt.',
        'EV',
        'SE',
        'SCE',
        'Kht.',
    ],
    ISL: [
        'hf',
        'ehf',
        'sf',
        'ses',
        'slf',
        'se',
        'sfs',
        'einstaklingsfyrirtæki',
        'samvinnufélag',
        'samvinnusamband',
    ],
    IRL: [
        'Ltd',
        'PLC',
        'DAC',
        'CLG',
        'UC',
        'SE',
        'SCE',
        'ICAV',
        'LP',
        'GP',
    ],
    ITA: [
        'S.r.l.',
        'S.p.A.',
        'S.a.p.a.',
        'S.n.c.',
        'S.a.s.',
        'SE',
        'SCE',
        'Coop',
        'Impresa Individuale',
        'GEIE',
    ],
    LVA: [
        'SIA',
        'AS',
        'PS',
        'KS',
        'IK',
        'SE',
        'SCE',
        'ZS',
        'PV',
        'UZ',
    ],
    LUX: [
        'SARL',
        'SA',
        'SCSp',
        'SE',
        'SCA',
        'SNC',
        'SCS',
        'SComm',
        'CoopSA',
        'CoopSARL',
    ],
    MLT: [
        'Ltd',
        'PLC',
        'GP',
        'LP',
        'SE',
        'SCE',
        'PGP',
        'LLP',
        'SP',
        'Coop',
    ],
    NLD: [
        'BV',
        'NV',
        'CV',
        'VOF',
        'SE',
        'SCE',
        'ST',
        'Maatschap',
        'eenmanszaak',
        'SA',
    ],
    POL: [
        'Sp. z o.o.',
        'S.A.',
        'Sp.k.',
        'S.C.',
        'Sp.j.',
        'SE',
        'SCE',
        'P.S.A.',
        'spółdzielnia',
        'ZO',
    ],
    PRT: [
        'Lda.',
        'S.A.',
        'Unip.',
        'SGPS',
        'ACE',
        'CRL',
        'SE',
        'SCE',
        'SROC',
        'SU',
    ],
    ROU: [
        'SRL',
        'SA',
        'SNC',
        'SCS',
        'SCA',
        'SE',
        'SCE',
        'PFA',
        'II',
        'IF',
    ],
    SVK: [
        's.r.o.',
        'a.s.',
        'k.s.',
        'v.o.s.',
        'družstvo',
        'SE',
        'SCE',
        'živnostník',
        'štátny podnik',
        'organizačná jednotka',
    ],
    SVN: [
        'd.o.o.',
        'd.d.',
        'k.d.',
        'd.n.o.',
        's.p.',
        'z.o.o.',
        'SE',
        'SCE',
        'zadruga',
        'GIZ',
    ],
    ESP: [
        'S.L.',
        'S.A.',
        'S.L.U.',
        'S.A.U.',
        'S.C.P.',
        'S.C.',
        'SE',
        'SCE',
        'Coop',
        'AIE',
    ],
    SWE: [
        'AB',
        'HB',
        'KB',
        'Ek.för',
        'BRF',
        'SE',
        'SCE',
        'Stiftelse',
        'Kommanditbolag',
        'förening',
    ],
    GBR: [
        'Ltd',
        'PLC',
        'LLP',
        'CIC',
        'GUAR',
        'SE',
        'LP',
        'LLC',
        'CLG',
        'RSL',
    ],
    CHE: [
        'AG',
        'GmbH',
        'KIG',
        'Genossenschaft',
        'Stiftung',
        'Verein',
        'SE',
        'Kommanditgesellschaft',
        'Einzelfirma',
        'GbR',
    ],
    NOR: [
        'AS',
        'ASA',
        'ANS',
        'KS',
        'DA',
        'NUF',
        'SA',
        'BA',
        'Stiftelse',
        'Enkeltpersonforetak',
    ],
    TUR: [
        'A.Ş.',
        'L.t.d. Şti.',
        'Kollektif Şirket',
        'Komandit Şirket',
        'Kooperatif',
        'İş Ortaklığı',
        'Adi Komandit Şirket',
        'Adi Ortaklık',
        'İktisadi İşletme',
        'Büyükşehir Belediye İktisadi İşletmesi',
    ],
    ARE: [
        'LLC',
        'PJSC',
        'PrJSC',
        'SPC',
        'Branch',
        'Representative Office',
        'FZ LLC',
        'FZ Co',
        'Civil Company',
        'JV',
    ],
    MCO: [
        'SAM',
        'SARL',
        'SNC',
        'SCS',
        'SCI',
        'SCA',
        'SE',
        'Groupement d\'Intérêt Economique',
        'Succursale',
        'Association',
    ],
    LIE: [
        'AG',
        'GmbH',
        'Anstalt',
        'Stiftung',
        'Establishment',
        'Trust',
        'Genossenschaft',
        'SE',
        'Kollektivgesellschaft',
        'Kommanditgesellschaft',
    ],
    JOR: [
        'LLC',
        'PLC',
        'Ltd',
        'LLP',
        'Sole Proprietorship',
        'Branch Office',
        'Representative Office',
        'JV',
        'Holding Company',
        'Operating Company',
    ],
    AND: [
        'SL',
        'SA',
        'SCP',
        'Comunitat de Bens',
        'Cooperativa',
        'Societat Civil',
        'Associació',
        'Fundació',
        'Societat Col·lectiva',
        'Societat Comanditària',
    ],
    ALB: [
        'Sh.p.k.',
        'S.A.',
        'K.P.',
        'Sh.a.',
        'P.F.',
        'SE',
        'SCE',
        'S.H.A.',
        'Komandit',
        'Tregtar Individ',
    ],
    BIH: [
        'd.o.o.',
        'a.d.',
        'k.d.',
        's.p.',
        'z.o.o.',
        'd.d.',
        'se',
        'o.d.',
        'zadruga',
        'udruženje',
    ],
    MNE: [
        'd.o.o.',
        'a.d.',
        'k.d.',
        'o.d.',
        'DOO',
        'AD',
        'SE',
        'SCE',
        'preduzetnik',
        'zadruga',
    ],
    MKD: [
        'DOO',
        'AD',
        'KD',
        'OOD',
        'OOZD',
        'SE',
        'SCE',
        'ZTP',
        'SOZD',
        'ZDD',
    ],
    SRB: [
        'd.o.o.',
        'a.d.',
        'k.d.',
        'o.d.',
        'p.d.',
        'SE',
        'SCE',
        'zadruga',
        'samostalni preduzetnik',
        'agencija',
    ],
    UKR: [
        'ТОВ',
        'ПАТ',
        'ПрАТ',
        'ФОП',
        'КП',
        'ТДВ',
        'ОДВ',
        'ДП',
        'ПП',
        'ТОВ (з обмеженою відповідальністю)',
    ],
    MAR: [
        'SARL',
        'SA',
        'SNC',
        'SCS',
        'SCA',
        'SAS',
        'GIE',
        'Groupement d\'intérêt économique',
        'Groupement Agricole',
        'Association',
    ],
    QAT: [
        'LLC',
        'QSC',
        'SPC',
        'Branch',
        'Representative Office',
        'JV',
        'Holding Company',
        'Public Shareholding Company',
        'Private Shareholding Company',
        'Partnership',
    ],
    DZA: [
        'SPA',
        'EURL',
        'SARL',
        'SNC',
        'SCS',
        'GIE',
        'Entrepreneur individuel',
        'Coopérative',
        'SCA',
        'ETS',
    ],
    EGY: [
        'SAE',
        'LLC',
        'SNC',
        'SCS',
        'SPC',
        'Branch',
        'Representative Office',
        'JV',
        'Partnership',
        'Holding Company',
    ],
};
